import {Component} from "@angular/core";
import {isGame} from "src/app/utils/works-type-guards.util";
import {GameCompletionLabels} from "src/app/enums/Game";
import {BaseEditWorkDatesComponent} from "../base-edit-work-dates/base-edit-work-dates.component";
import {GameCompletion} from "src/app/modules/auth/models/User";
import {EditWorkCompletionDatesComponent} from "../edit-work-completion-dates/edit-work-completion-dates.component";
import {TranslateModule} from "@ngx-translate/core";
import {WorkTimeHistoryComponent} from "../../../works/components/work-time-history/work-time-history.component";

@Component({
  selector: "app-edit-game-dates",
  templateUrl: "./edit-game-dates.component.html",
  imports: [
    EditWorkCompletionDatesComponent,
    TranslateModule,
    WorkTimeHistoryComponent,
  ],
})
export class EditGameDatesComponent extends BaseEditWorkDatesComponent {
  public isGame = isGame;
  public completionLabels = GameCompletionLabels;

  public getCompletionLabels(completion: string) {
    return GameCompletionLabels[
      completion as keyof typeof GameCompletionLabels
    ];
  }

  trackByFn(_index: number, item: GameCompletion) {
    return item.completion;
  }
}
